import "./treetable.css"; // Ensure the correct path to your CSS file

import { noSeq, outsideTree, srceNames, srceSeqIds } from "../../utils/utils";

import Col from "react-bootstrap/Col"; // Import Col for additional layout control if needed
import Heatmap from "./Heatmap.js";
import MissingSrces from "../TreeView/MissingSrces";
import PhyloTable from "./Table.js";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";
import Table from "react-bootstrap/Table";
import TreeTableMenu from "./TreeTableMenu";
import { useSurveyMode } from "../../contexts/SurveyModeProvider";
import { useSelector } from "react-redux";

export default function TreeTable(micro_id) {
  const { debug_mode } = useSurveyMode();

  const newickTree = useSelector(state => state.patient.tree.tree);
  const ptObj = useSelector((state) => state.patient.patient);
  const nameMap = useSelector(state => state.patient.tree.name_map);
  const idx_patient = useSelector((state) => state.patient.patient.pt.name);
  const heatmap_select = useSelector(
    (state) => state.patient.tree.heatmap_selected
  );
  var matrix = useSelector(state => state.patient.tree.distance_matrix);
  const firstPosDate = new Date(ptObj.pt.first_positive);
  const showFutureSequences = useSelector(state => state.patient.tree.show_future_sequences);

  // Check if after the first positive date if !showFutureSequences
  const filterFutureSequences = (matrix, nameMap) => {
    const isValidDate = (dateString) => {
      const date = new Date(dateString);
      return date && (date <= firstPosDate || showFutureSequences);
    };
    const filteredMatrix = {};
    for (const id1 in matrix) {
      if (nameMap[id1] && isValidDate(nameMap[id1][2])) {
        filteredMatrix[id1] = {};
        for (const id2 in matrix[id1]) {
          if (nameMap[id2] && isValidDate(nameMap[id2][2])) {
            filteredMatrix[id1][id2] = matrix[id1][id2];
          }
        }
        if (Object.keys(filteredMatrix[id1]).length === 0) {
          delete filteredMatrix[id1];
        }
      }
    }
    return filteredMatrix;
  };

  const idsToNames = (matrix, mapping) => {
    const mapped = {};

    for (const id1 in matrix) {
      const name1 = mapping[id1] ? mapping[id1][0] : id1;
      mapped[name1] = {};

      for (const id2 in matrix[id1]) {
        const name2 = mapping[id2] ? mapping[id2][0] : id2;
        mapped[name1][name2] = matrix[id1][id2];
      }
    }
    return mapped;
  };

  matrix = idsToNames(filterFutureSequences(matrix, nameMap), nameMap);

  // Check if the matrix has more than one key (data) before rendering
  const shouldRenderHeatmap = Object.keys(matrix).length > 1;

  return (
    <>
      {matrix === undefined || newickTree === undefined ? (
        <Spinner animation="border" />
      ) : (
        <>
          {newickTree.tree === null ? (
            <Row>
              <Col>
                <p>This patient has no pathogen sequencing data.</p>
              </Col>
            </Row>
          ) : (
            <>
              <TreeTableMenu
                seqIds={srceSeqIds(ptObj)}
                indexSeqId={ptObj.pt.seq_id}
                noSeq={noSeq(ptObj, nameMap)}
                debug_mode={debug_mode}
              />
              {shouldRenderHeatmap && heatmap_select ? (
                <Row>
                  <Col>
                    <Heatmap idx_pt={idx_patient} distance_matrix={matrix} />
                  </Col>
                </Row>
              ) : (
                <>
                  {matrix && Object.keys(matrix).length > 1 && matrix[idx_patient] ? (
                    <Row>
                      <Col style={{ marginLeft: "10%" }}>
                        <PhyloTable
                          idx_pt={idx_patient}
                          distances={matrix[idx_patient]}
                        />
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col style={{ paddingTop: "50px", paddingBottom: "50px", textAlign: "center"}}>
                        <p>No genetically related cases to display.</p>
                      </Col>
                    </Row>
                  )}
                </>
              )}
              <Row>
                <MissingSrces ptObj={ptObj}></MissingSrces>
              </Row>
            </>
          )}
        </>
      )}
    </>
  );
}
